import { type RefrigerationUnit } from '@/data/schemas';
import type { RefrigerationUnitTechnicalInput } from '@/data/repos/refrigerationUnitsRepo';
import { buildSafetyDefaults, buildSafetyValues, safetyToInput } from './safetyFields';
import { buildDischargeDefaults, buildDischargeValues, dischargeToInput } from './dischargeFields';
import type { RefrigerationUnitFormValues } from './shared';

/**
 * Combined defaults for Emergenza & Continuità subtab.
 * Includes: Comunicazioni, Sistemi di emergenza, Sistemi di sicurezza,
 * Alimentazione e backup, Valvole di sicurezza
 */
export const buildEmergenzaCombinedDefaults = (): Partial<RefrigerationUnitFormValues> => ({
  ...buildSafetyDefaults(),
  ...buildDischargeDefaults(),
});

/**
 * Combined values extractor for Emergenza & Continuità subtab.
 */
export const buildEmergenzaCombinedValues = (
  refrigerationUnit: RefrigerationUnit
): Partial<RefrigerationUnitFormValues> => ({
  ...buildSafetyValues(refrigerationUnit),
  ...buildDischargeValues(refrigerationUnit),
});

/**
 * Combined input converter for Emergenza & Continuità subtab.
 */
export const emergenzaCombinedToInput = (
  values: RefrigerationUnitFormValues
): Pick<
  NonNullable<RefrigerationUnitTechnicalInput['safety']>,
  'emergencySystems' | 'powerBackup' | 'valves'
> => {
  const { emergencySystems, powerBackup } = safetyToInput(values);
  const { valves } = dischargeToInput(values);

  return {
    emergencySystems,
    powerBackup,
    valves,
  };
};
